<template>
  <NavbarOne />
  <PageBanner
    pageTitle="المدونة التقنية"
    subTitle="كل ما تحتاجه لتتقن عالم الـ IPTV: أدلة احترافية، حلول تقنية، ونصائح لضمان تجربة مشاهدة لا تضاهى."
    :pageBannerImage="pageBannerImg"
  />
  <Blog />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import Blog from "@/components/Blog/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "BlogPage",
  components: {
    NavbarOne,
    PageBanner,
    Blog,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "المدونة التقنية | دليل IPTV والأخبار والشروحات",
      meta: [
        {
          name: "description",
          content:
            "تابع أحدث المقالات والشروحات التقنية حول IPTV، القنوات العربية، الأفلام والمسلسلات، حلول المشاكل، وأفضل النصائح للحصول على أفضل تجربة مشاهدة بجودة HD و4K.",
        },
        {
          name: "keywords",
          content:
            "مدونة IPTV, شروحات IPTV, أخبار IPTV, دليل IPTV, قنوات عربية, أفلام, مسلسلات, بث مباشر, HD, 4K",
        },
        {
          property: "og:title",
          content: "المدونة التقنية | دليل IPTV والأخبار والشروحات",
        },
        {
          property: "og:description",
          content:
            "اكتشف أحدث المقالات والشروحات والنصائح المتعلقة بخدمات IPTV والقنوات العربية والأفلام والمسلسلات.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/blog",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-6.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>